export default __webpack_public_path__ + "e410a532c50946e1c252c0862656a96e.ttf";